import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useTranslation from 'next-translate/useTranslation'
import { twMerge } from 'tailwind-merge'

export interface ShowMoreProps {
  showMore?: boolean
  onClick: (event: React.BaseSyntheticEvent) => void
  className?: string
}

export function ShowMore({ showMore, onClick, className }: ShowMoreProps) {
  const { t } = useTranslation()
  return (
    <div
      onClick={onClick}
      className={twMerge(
        'border-shades-200 cursor-pointer border-t bg-white p-[10px] text-center text-sm font-bold tracking-widest',
        className
      )}
    >
      {showMore ? t('ui:show-more.show-less') : t('ui:show-more.show-more')}
      <FontAwesomeIcon icon={showMore ? faChevronUp : faChevronDown} className="text-md pl-2" />
    </div>
  )
}
